// HD Image Assets - 4K Quality
import howInitiateHD from "@/assets/how-initiate-v2.webp";
import howContextHD from "@/assets/how-context-v2.webp";
import howDocumentHD from "@/assets/how-document-v2.webp";
import trainExpertsHD from "@/assets/train-experts-v2.webp";
import benefitTeamHD from "@/assets/benefit-team-v2.webp";
import benefitTimingHD from "@/assets/benefit-timing-new.mp4";
import benefitSecurityHD from "@/assets/benefit-security-v2.webp";
import problemTimeHD from "@/assets/problem-time-v2.webp";
import solutionCartHD from "@/assets/solution-cart-v2.webp";
import techDevicesHD from "@/assets/tech-devices-v2.webp";
import techUIHD from "@/assets/tech-ui-v2.webp";
import marketGrowthHD from "@/assets/market-growth-v2.webp";
import businessRevenueHD from "@/assets/business-revenue-v2.webp";
import securityComplianceHD from "@/assets/security-compliance-v2.webp";
import securityQuantumHD from "@/assets/security-quantum-v2.webp";
import mosaicICUHD from "@/assets/mosaic-icu-v2.webp";
import mosaicMedsHD from "@/assets/mosaic-meds-v2.webp";
import mosaicDefibHD from "@/assets/mosaic-defib-new.mp4";
import mosaicTeamHD from "@/assets/mosaic-team-v2.webp";
import mosaicLeadHD from "@/assets/mosaic-lead-v2.webp";

export const hdImages = {
  howInitiate: howInitiateHD,
  howContext: howContextHD,
  howDocument: howDocumentHD,
  trainExperts: trainExpertsHD,
  benefitTeam: benefitTeamHD,
  benefitTiming: benefitTimingHD,
  benefitSecurity: benefitSecurityHD,
  problemTime: problemTimeHD,
  solutionCart: solutionCartHD,
  techDevices: techDevicesHD,
  techUI: techUIHD,
  marketGrowth: marketGrowthHD,
  businessRevenue: businessRevenueHD,
  securityCompliance: securityComplianceHD,
  securityQuantum: securityQuantumHD,
  mosaicICU: mosaicICUHD,
  mosaicMeds: mosaicMedsHD,
  mosaicDefib: mosaicDefibHD,
  mosaicTeam: mosaicTeamHD,
  mosaicLead: mosaicLeadHD,
};
